export default __webpack_public_path__ + "4f0d5d2de9cc021ffe0e0588af56a2cf.png";